import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { login } from '../services/api';
import './StaffLogin.css';

function StaffLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      toast.error('Please enter username and password');
      return;
    }

    setLoading(true);

    try {
      const response = await login(username, password);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('staff_profile', JSON.stringify(response.data.staff_profile));
      toast.success('Login successful!');
      
      // Route based on role
      const role = response.data.staff_profile.role;
      if (role === 'report_viewer') {
        navigate('/staff/reports');
      } else {
        navigate('/staff/dashboard');
      }
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error('Invalid username or password');
      } else if (error.response?.status === 403) {
        toast.error(error.response.data.error || 'Access denied');
      } else {
        toast.error('Login failed. Please try again.');
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="staff-login">
      <div className="login-container">
        <div className="card login-card">
          <div className="login-header">
            <h1>Xodim kirish</h1>
            <p>BDTU navbat dasturi</p>
          </div>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                autoComplete="username"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                autoComplete="current-password"
              />
            </div>
            
            <button 
              type="submit" 
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
          
          <div className="login-footer">
            <p>
              <a href="/student">Go to Student Kiosk</a>
            </p>
          </div>
        </div>
        
        {/* <div className="demo-credentials">
          <h3>Demo Credentials</h3>
          <div className="credentials-list">
            <div className="credential-item">
              <strong>Engineering:</strong> eng_staff1 / staff123
            </div>
            <div className="credential-item">
              <strong>Science:</strong> sci_staff1 / staff123
            </div>
            <div className="credential-item">
              <strong>Arts:</strong> art_staff1 / staff123
            </div>
            <div className="credential-item">
              <strong>Business:</strong> bus_staff1 / staff123
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default StaffLogin;
